module.exports = __webpack_public_path__ + "static/media/brand-logo.f4141bd2.png";